export default {
  baseUrl : document.head.querySelector("[property~=base-url][content]").content
};
